import Vue from 'vue'
import Router from 'vue-router'
//import {store} from '../store.js'

import MasterPage from '../components/MasterPage.vue'
import ClientPage from '../components/ClientPage.vue'
import GalleryList from '../components/GalleryList.vue'
import GalleryDetail from '../components/GalleryDetail.vue'
import Budget from '../components/Budget.vue'
import LegalNotice from '../components/LegalNotice.vue'
import PrivacyPolicy from '../components/PrivacyPolicy.vue'
import ResetPassword from '../components/ResetPassword.vue'
import GalleryEditList from '../components/GalleryEditList.vue'
import GalleryEditElement from '../components/GalleryEditElement.vue'

import {store} from '../store.js'

Vue.use(Router)

function checkLoginGuard(to, from, next){
  let token = store.state.token;
  let expiryDate = store.state.expiryDate;

  if(!token || !expiryDate || Date.now() > Date.parse(expiryDate)){
    next(false);
  } else {
    next();
  }
}

export default new Router({
  mode: "history", //no # at the start of routes
  routes: [
    {
      path: '/',
      component: MasterPage,
      children: [
        {
          path: '/',
          name: "ClientPage",
          component: ClientPage
        },
        {
          path: '/gallery',
          name: 'Gallery',
          component: GalleryList,
          children: [
            { path: '/gallery/:id', name: "GalleryDetail", component: GalleryDetail }
          ]
        },
        {
          path: '/budget',
          name: 'Budget',
          component: Budget
        },
        {
          path: '/legal',
          name: 'LegalNotice',
          component: LegalNotice
        },
        {
          path: '/privacy',
          name: 'PrivacyPolicy',
          component: PrivacyPolicy
        },
        {
          path: '/resetPassword/:token',
          name: 'ResetPassword',
          component: ResetPassword
        },
        {
          path: '/editGallery',
          name: 'GalleryEditList',
          component: GalleryEditList,
          beforeEnter: checkLoginGuard
        },
        {
          path: '/editGallery/:id',
          name: 'GalleryEditElement',
          component: GalleryEditElement,
          beforeEnter: checkLoginGuard
        }
      ]
    }
  ]
  
})
